module.exports = __webpack_public_path__ + "img/tg-icon.0871f78d.svg";